
/* ------------------------------------------------------------------------ */
/*		File: About.tsx                                                     */
/*		Description: About page definition                                  */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import Slider from "react-slick";
import Menu from "../../components/cmpMenu/cmpMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import About from "../../components/cmpAboutUs/cmpAboutUs";
import Headquarters from "../../components/cmpHeadquarters/cmpHeadquarters";
import Card_340 from "../../components/cmpCard_340/cmpCard_340";
import Card_210 from "../../components/cmpCard_210/cmpCard_210";
import Card_310 from "../../components/cmpCard_310/cmpCard_310";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";
import { getImage } from "../../components/GenericComponents/functions";

import "./about.css";
import "../../scss/general.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Meta from "../../components/GenericComponents/meta";


/* ------------------------------------------------------------------------ */


const AboutUs: React.FC = () => {
    const { t } = useTranslation();
    const [slider, setSlider] = useState<any>(null);

    const infoMenus: any = t("menu", { returnObjects: true });
    const infoAboutUs: any = t("aboutus", { returnObjects: true });
    const detailMenu = infoMenus.filter((x: any) => x.id === "aboutus")[0] || null;

    const sliderSettings = {
        arrows: false,
        dots: false,

        centerMode: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 500,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }


    return (
        <div className="header-parent ">
            <Meta page={"aboutUs"} />
            <div className="cssAbout">
                <Menu
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                />
                <div className="cssCol">
                    <Card_Breadcumb label={infoAboutUs.breadcumb} />

                    {/* Section: About us */}

                    <section id="aboutus">
                        <IntroComponent
                            label={infoAboutUs.label}
                            description={infoAboutUs.description}
                        />
                        <About card={infoAboutUs.content[0].content} />
                    </section>

                    {/* Section: Headquarters  */}

                    <section id="ourHeadquarters">
                        <IntroComponent
                            label={infoAboutUs.content[1].label}
                            description={infoAboutUs.content[1].description}
                        />
                        <Headquarters
                            options={infoAboutUs.content[1].content}
                            src={infoAboutUs.content[1].urlImage}
                        />
                    </section>

                    {/* Section: Team Profiles  */}

                    <section id="teamProfiles">
                        <IntroComponent
                            label={infoAboutUs.content[2].label}
                            description={infoAboutUs.content[2].description}
                        />
                        <div className="cssRowBetween achievement_stats">
                            {infoAboutUs.content[2].content.map((item: any, index: number) => (
                                <Card_340
                                    key={`Card_340-infoAboutUs-${index}`}
                                    card={item}
                                />
                            ))}
                        </div>
                    </section>

                    {/* Section: Achievements  */}

                    <section id="achievements">
                        <IntroComponent
                            label={infoAboutUs.content[3].label}
                            description={infoAboutUs.content[3].description}
                        />
                        <div className="cssRowBetween achievement_stats">
                            {infoAboutUs.content[3].content.map((item: any, index: number) => (
                                <Card_210
                                    key={`Card_210-infoAboutUs-${index}`}
                                    card={item}
                                />
                            ))}
                        </div>
                    </section>

                    {/* Section: Testimonials  */}


                    <section id="testimonials">
                        <IntroComponent
                            label={infoAboutUs.content[4].label}
                            description={infoAboutUs.content[4].description}
                        />
                        <div className="cssRowBetween">
                            <div className="cssSliderContainer">
                                <button
                                    className="card_about_button left"
                                    onClick={() => slider?.slickPrev()}
                                >
                                    <img src={getImage("chevron-left.svg")} alt="chevron-left.svg" />
                                </button>
                                <button
                                    className="card_about_button right"
                                    onClick={() => slider?.slickNext()}
                                >
                                    <img src={getImage("chevron-right.svg")} alt="chevron-right.svg" />
                                </button>
                                <Slider ref={(c: any) => setSlider(c)}{...sliderSettings}>
                                    {infoAboutUs.content[4].content.map((item: any, index: number) => (
                                        <Card_310
                                            key={`Card_310-infoAboutUs-${index}`}
                                            card={item}
                                        />
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </section>


                </div>
            </div>

        </div>
    );
};
export default withTranslation('translation', { withRef: true })(AboutUs);